import { constants } from '../constants/constants';
import { IWorkOrder } from '../models';

// UK and Canada number a job created from work orders after the work order itself
const workOrderJobNumberCountryIDs: string[] = [
    constants.ukCountryID,
    constants.canadaCountryID
];

/*
 * getDefaultJobNumber
 * the job number to prefill when creating a job from work orders.
 * UK and Canada facilities use the first selected work order's number, everyone else the next auto number.
 */
export const getDefaultJobNumber = (
    countryID: string | undefined,
    workOrders: IWorkOrder[],
    nextJobNumber: string
): string => {
    if (!countryID || !workOrderJobNumberCountryIDs.includes(countryID)) {
        return nextJobNumber;
    }
    const numberedWorkOrder = workOrders.find(wo => wo.number);
    return numberedWorkOrder?.number || nextJobNumber;
};
